module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0054.jpg?v=520bd368";